import React, { PureComponent, createRef } from 'react';
import { connect } from 'react-redux';
import DelayResult from './verification/DelayResult';
import ImpedanceResult from './verification/ImpedanceResult';
import ImpedanceSweep from './sweep/ImpedanceSweep';
import DelaySweep from './sweep/DelaySweep';
import Waveform from './verification/WaveForm';
import WaveformSweep from './sweep/WaveForm';
import { SettingOutlined, TableOutlined } from '@ant-design/icons';
import { Select, message } from 'antd';
import { changeResultKey, saveCurrentSimulationConfig } from '../store/result/action';
import { updateExperimentInfo } from '../store/sweep/action';
import { EXPERIMENTS_RESULT } from '@/constants/treeConstants';
import Channel from './verification/Sparameter';
import SweepChannel from './sweep/Sparameter';
import EyeDiagrams from './eyeDiagrams';
import { ResultData, SweepResultData } from '@/services/Sierra';
import { EXPERIMENTS, RESULT, VERIFICATION } from '../../../constants/treeConstants';
import { updateMultiInterfaceSetupStatus } from '../store/multiInterface/action';
import TopMenu from './topMenu';
import { openNewPage } from '../store/project/action';
import TotalTraceCapacitance from './verification/totalTraceCapacitance';
import { CAPACITANCE, CHANNEL, DELAY, EYE_DIAGRAMS, IMPEDANCE, WAVEFORM } from '../../../services/Result/Public/resultConstants';
import resultOperation from '../../../services/Result/Public/resultOperation';
import '@/publicCss/waveform.css';
import './index.css';
import { SweepData } from '../../../services/Sierra';
import { getSignalNameObjByVerificationJson } from '../../../services/Sierra/results/dataHandle';
import designConstructor from '../../../services/helper/designConstructor';
import { SCHEMATIC } from '../../../services/Sierra/prelayout/prelayoutConstants';

class Result extends PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      hasResult: true,
      experimentResult: [],
      hasChannel: false,
      hasMeasurement: false,
      hasVictim: false,
      rightVisible: {},
      interfaceTag: null,
      hasCapacitance: false,
      sweepListStatus: false,
      expKeyStatus: false
    }

    this.verificationJson = null;
    this.resultRef = createRef();
  }

  componentDidMount() {
    const { viewList, verificationSubId, sweepId } = this.props;

    if (viewList.includes(EXPERIMENTS_RESULT)) {
      if (sweepId) {
        this.setState({
          interfaceTag: null,
          sweepListStatus: false
        }, () => {
          this.getSweepInfo();
        })

      }
    } else {
      if (verificationSubId) {
        this.setState({
          interfaceTag: null
        }, () => {
          this.getInfo();
        })
      }
    }

    this.getResultSetting()
  }

  componentDidUpdate(prevProps) {
    const { viewList, verificationSubId, sweepId, verificationId, expVerificationId } = this.props;

    if ((!prevProps.verificationId && verificationId) || (!prevProps.expVerificationId && expVerificationId)) {
      this.getResultSetting()
    }

    const view = viewList.find(item => [EXPERIMENTS_RESULT, RESULT].includes(item));
    const prevView = prevProps.viewList ? prevProps.viewList.find(item => [EXPERIMENTS_RESULT, RESULT].includes(item)) : null;
    let updateInfo = false;
    if (view !== prevView) {
      updateInfo = true;
    }
    switch (view) {
      case EXPERIMENTS_RESULT:
        if (sweepId !== prevProps.sweepId || updateInfo) {
          this.setState({
            interfaceTag: null,
            sweepListStatus: false
          }, () => {
            this.getSweepInfo();
          })
        }
        break;
      case RESULT:
        if (prevProps.verificationSubId !== verificationSubId
          || prevProps.verificationId !== verificationId
          || updateInfo) {
          this.setState({
            interfaceTag: null
          }, () => {
            this.getInfo();

          })
        }
        break;
      default: break;
    }
  }

  getResultSetting = async () => {
    const { verificationId, expVerificationId, viewList } = this.props;

    const isSweep = viewList.includes(EXPERIMENTS_RESULT);
    if (isSweep) {
      if (expVerificationId) {
        await resultOperation.getSettings(expVerificationId)
      }
    } else {
      if (verificationId) {
        await resultOperation.getSettings(verificationId)
      }
    }
  }

  getInfo = async () => {
    const { verificationSubId, currentProjectId, verificationId, currentResultKey, currentProjectVerifications } = this.props;
    if (!verificationId) {
      return;
    }

    const findV = (currentProjectVerifications || []).find(item => item.id === verificationId) || {};
    this.setState({
      interfaceTag: findV.type
    })
    let preLayoutInfoList = []
    try {
      preLayoutInfoList = await ResultData.getPreLayoutJsonByVerificationId(verificationId);
    } catch (error) {
      console.error(error);
    }
    // get current result verification.json
    ResultData.getVerificationJsonPromise(verificationSubId, verificationId, currentProjectId).then(res => {
      if (res && res.Config) {
        this.props._saveCurrentSimulationConfig(res.Config);
      }
      let hasChannel = false, hasCapacitance = false;
      ////add network s-parameter (channel) menu
      if (res && res.Interfaces
        && res.Interfaces.find(item => item.content && item.content.channel && ["SIwave", "HFSS", "PowerSI"].includes(item.content.channel.type))) {
        hasChannel = true;
        hasCapacitance = true;
      }

      const filterPreLayout = res ? (res.Interfaces || []).filter(item => designConstructor.isPreLayout(item.PCBID)) : [];

      if (filterPreLayout.length) {
        let isTemplateSchematic = false;
        for (let item of filterPreLayout) {
          //designId and subId is design subId, id is curr design ID
          const findInfo = preLayoutInfoList.find(it => it.subId === item.pcbId || it.id === item.PCBID || it.designId === item.pcbId);
          isTemplateSchematic = findInfo && findInfo.content && findInfo.content.prelayout === SCHEMATIC && (!findInfo.content.mode || findInfo.content.mode === "Template");
          if (isTemplateSchematic) {
            hasCapacitance = true;
            break;
          }
        }
      }

      if ((!hasChannel && currentResultKey === CHANNEL) || (!hasCapacitance && currentResultKey === CAPACITANCE)) {
        this.changeResultType({ key: IMPEDANCE });
      }

      const hasVictim = res && res.Config ? res.Config.enableVictim || false : false;
      if (hasVictim) {
        this.verificationJson = { ...res, verificationId };
      }
      this.setState({
        hasResult: res ? true : false,
        hasChannel,
        hasMeasurement: true,
        hasCapacitance,
        hasVictim
      });

    }, () => {
      this.setState({
        hasResult: false,
        hasChannel: false,
        hasCapacitance: false
      });
      if ([CAPACITANCE, CHANNEL].includes(currentResultKey)) {
        this.changeResultType({ key: IMPEDANCE });
      }
    })
  }

  getSweepInfo = async (isExpKey = false) => {
    const { currentProjectId, experimentsList, currentResultKey, currentProjectVerifications, sweepId } = this.props;
    let experimentResult = [];
    if ([EYE_DIAGRAMS, CAPACITANCE].includes(currentResultKey)) {
      this.changeResultType({ key: IMPEDANCE });
    }
    const rootVerificationId = SweepData.getExpRootVerificationId(sweepId);
    const findV = (currentProjectVerifications || []).find(item => item.id === rootVerificationId) || {};
    this.setState({
      interfaceTag: findV.type
    })
    let hasChannel = false, isUpdateMenu = false, designs = [];
    for (let item of experimentsList) {
      if (item.show) {
        const res = await SweepResultData.getVerificationJsonPromise(item.id, currentProjectId)
        if (res && res.length) {
          experimentResult.push({ id: item.id, name: item.name, channelList: item.channelList, show: item.show, verificationId: item.verificationId });
          //if support eye diagram, need this config
          /*  if (res.Config && !saveConfig.length) {
            this.props._saveCurrentSimulationConfig(res.Config);
            saveConfig.push(res.Config);
          } */
          //add network s-parameter (channel) menu
          if (!isUpdateMenu
            && res.find(it => it.content && it.content.channel && ["SIwave", "HFSS", "PowerSI"].includes(it.content.channel.type))) {
            hasChannel = true;
            isUpdateMenu = true;
          }

          const _designs = res ? res.map(item => item.PCBID) : [];
          designs.push(..._designs);
        } else {
          message.error(`The result of ${item.name} does not exist`);
        }
      }
    }
    this.setState({
      hasChannel,
      experimentResult,
      hasMeasurement: true
    })
    if (isExpKey) {
      this.setState({
        expKeyStatus: true
      })
    } else {
      this.setState({
        sweepListStatus: true
      })
    }
  }

  getResultContent = () => {
    const { currentResultKey, siderLeftWidth, layoutLeftWidth } = this.props;
    const { hasResult, rightVisible, interfaceTag, hasVictim } = this.state;
    if (!hasResult) {
      return null;
    }
    const signalNameObj = hasVictim ? getSignalNameObjByVerificationJson(this.verificationJson) : {};
    switch (currentResultKey) {
      case IMPEDANCE:
        return <ImpedanceResult hasVictim={hasVictim} />
      case DELAY:
        return <DelayResult hasVictim={hasVictim} signalNameObj={signalNameObj} />
      case WAVEFORM:
        return <Waveform
          hasVictim={hasVictim}
          signalNameObj={signalNameObj}
          measurePanelVisible={rightVisible["measurement"]}
          victimSummaryVisible={rightVisible["victimSummary"]}
          changeMeasureVisible={(visible) => this.changeRightMenuKey("measurement", visible)}
          changeVictimSummaryVisible={(visible) => this.changeRightMenuKey("victimSummary", visible)}
          interfaceTag={interfaceTag}
        />
      case CHANNEL:
        return <Channel hasVictim={hasVictim} />
      case EYE_DIAGRAMS:
        return <EyeDiagrams siderLeftWidth={siderLeftWidth} layoutLeftWidth={layoutLeftWidth} hasVictim={hasVictim} />;
      case CAPACITANCE:
        return <TotalTraceCapacitance hasVictim={hasVictim} signalNameObj={signalNameObj} />
      default:
        return null;
    }
  }

  updateSweepListStatus = (sweepListStatus) => {
    this.setState({
      sweepListStatus
    })
  }

  updateExpKeyStatus = (expKeyStatus) => {
    this.setState({
      expKeyStatus
    })
  }

  getSweepResultContent = () => {
    const { currentResultKey, siderLeftWidth, layoutLeftWidth } = this.props;
    const { experimentResult, rightVisible, interfaceTag, sweepListStatus, expKeyStatus } = this.state;
    if (!experimentResult.length) {
      return null;
    }
    switch (currentResultKey) {
      case IMPEDANCE:
        return <ImpedanceSweep
          resultList={experimentResult}
          sweepListStatus={sweepListStatus}
          expKeyStatus={expKeyStatus}
          updateSweepListStatus={this.updateSweepListStatus}
          updateExpKeyStatus={this.updateExpKeyStatus}
        />
      case DELAY:
        return <DelaySweep
          resultList={experimentResult}
          sweepListStatus={sweepListStatus}
          expKeyStatus={expKeyStatus}
          updateSweepListStatus={this.updateSweepListStatus}
          updateExpKeyStatus={this.updateExpKeyStatus} />
      case WAVEFORM:
        return <WaveformSweep
          resultList={experimentResult}
          measurePanelVisible={rightVisible["measurement"]}
          victimSummaryVisible={rightVisible["victimSummary"]}
          changeMeasureVisible={(visible) => this.changeRightMenuKey("measurement", visible)}
          changeVictimSummaryVisible={(visible) => this.changeRightMenuKey("victimSummary", visible)}
          interfaceTag={interfaceTag}
          sweepListStatus={sweepListStatus}
          expKeyStatus={expKeyStatus}
          updateSweepListStatus={this.updateSweepListStatus}
          updateExpKeyStatus={this.updateExpKeyStatus}
        />
      case CHANNEL:
        return <SweepChannel
          experimentList={experimentResult}
          sweepListStatus={sweepListStatus}
          expKeyStatus={expKeyStatus}
          updateSweepListStatus={this.updateSweepListStatus}
          updateExpKeyStatus={this.updateExpKeyStatus} />
      case EYE_DIAGRAMS:
        return <EyeDiagrams
          siderLeftWidth={siderLeftWidth}
          layoutLeftWidth={layoutLeftWidth}
          sweepListStatus={sweepListStatus}
          expKeyStatus={expKeyStatus}
          updateSweepListStatus={this.updateSweepListStatus}
          updateExpKeyStatus={this.updateExpKeyStatus}
        />
      case CAPACITANCE:
      default:
        return null;
    }
  }

  changeResultType = ({ key }) => {
    const { viewList } = this.props;
    if (key === "setup") {
      const { multiSetupResult, verificationId, sweepId } = this.props;
      if (multiSetupResult) {
        this.props._updateMultiInterfaceSetupStatus(multiSetupResult)
      } else {
        let pageType = VERIFICATION, id = verificationId;
        if (viewList.includes(EXPERIMENTS_RESULT)) {
          pageType = EXPERIMENTS;
          id = sweepId;
        }
        this.props._openNewPage({ pageType, id })
      }
      return;
    }
    this.props.changeResultKey(key);

    if (key === 'channel' && viewList.includes(EXPERIMENTS_RESULT)) {
      const { experimentsList } = this.props;
      const { experimentResult } = this.state;
      let newExperimentsList = experimentsList.map(item => {
        let show = item.show
        if (show && (!item.channelList || !item.channelList.length)) {
          show = false;
        }
        return { ...item, show }
      })
      const _experimentResult = experimentResult.filter(item => item.channelList && item.channelList.length);
      this.setState({
        experimentResult: _experimentResult,
        expKeyStatus: true
      })
      this.props.updateExperimentInfo(newExperimentsList, 'resultList');
    }
  }

  changeExperimentKey = (value) => {
    const { experimentsList } = this.props;
    const newExperimentsList = experimentsList.map(item => (
      { ...item, show: value.includes(item.id) ? true : false }
    ))
    this.props.updateExperimentInfo(newExperimentsList, 'resultList');
    setTimeout(() => {
      this.setState({
        sweepListStatus: false,
        expKeyStatus: false
      }, () => {
        this.getSweepInfo(true);
      })
    }, 100)
  }

  caclMaxTag = (value) => {
    let maxWidth = 240, count = 0; // Select box length - Tag Placeholder length
    const tagLength = 36; // Length of tag except characters
    for (let key of value) {
      let length = key.length < 12 ? key.length * 8 : 12 * 8; // 7 = one character length
      maxWidth = maxWidth - length - tagLength;
      if (maxWidth < 0) {
        break;
      } else {
        count = count + 1;
      }
    }
    return count
  }

  getExperimentShowList = () => {
    const { experimentsList, currentResultKey } = this.props;
    const show = experimentsList.filter(item => item.show);
    const value = show.map(item => item.id);
    const maxTagCount = this.caclMaxTag(show.map(item => item.name));
    return <div className="sierra-result-experiment-display">
      <Select
        className="aurora-select sierra-result-experiment-select"
        size='small'
        mode='multiple'
        value={value}
        maxTagCount={maxTagCount}
        maxTagTextLength={12}
        maxTagPlaceholder={`+${value.length - maxTagCount}`}
        onChange={this.changeExperimentKey}
        options={experimentsList.map(item => ({
          value: item.id,
          label: item.name,
          disabled: !item.exist || (currentResultKey === 'channel' && (!item.channelList || !item.channelList.length))
        }))}
      />
    </div>
  }

  getRightMenu = () => {
    const { currentResultKey } = this.props;
    const { hasMeasurement, hasVictim } = this.state;

    let menu = [];
    if (currentResultKey === WAVEFORM && hasMeasurement) {
      menu.push({
        key: "measurement",
        name: "Measurement",
        icon: SettingOutlined
      })
    }

    if (currentResultKey === WAVEFORM && hasVictim) {
      menu.push({
        key: "victimSummary",
        name: "Victim Summary",
        icon: TableOutlined
      })
    }
    return menu;
  }

  changeRightMenuKey = (key, visible) => {
    this.setState({
      rightVisible: { ...this.state.rightVisible, [key]: visible }
    })
  }

  render() {
    const { currentResultKey, viewList, siderLeftWidth, layoutLeftWidth, currentProgress, recalc, sweepReCalc, sweepMeasureProgress } = this.props;
    const { hasChannel, rightVisible, hasCapacitance, hasVictim } = this.state;
    const isSweep = viewList.includes(EXPERIMENTS_RESULT);
    const rightMenuList = this.getRightMenu()
    return (
      <div className='sierra-result-main' ref={this.resultRef}>
        <TopMenu
          selectedKey={currentResultKey}
          leftWidth={siderLeftWidth}
          layoutLeftWidth={layoutLeftWidth}
          hasChannel={hasChannel}
          hasCapacitance={hasCapacitance}
          hasVictim={hasVictim}
          viewList={viewList}
          isSweep={isSweep}
          changeResultType={(key) => this.changeResultType({ key })}
          getExperimentShowList={isSweep ? this.getExperimentShowList : null}
          rightMenuList={rightMenuList}
          changeRightMenuKey={this.changeRightMenuKey}
          rightVisible={rightVisible}
          recalc={recalc}
          sweepReCalc={sweepReCalc}
          progress={currentProgress}
          sweepMeasureProgress={sweepMeasureProgress}
        />
        <div className='sierra-result-content'>
          {isSweep ? this.getSweepResultContent() : this.getResultContent()}
        </div>
      </div>
    )
  }
}

const mapState = (state) => {
  const { resultReducer,
    project: { currentProjectId, currentProjectVerifications },
    sweep: { experimentInfo },
    multiInterfaceSetup: { multiSetupResult },
    simulationReducer: { singleProgress },
    resultReducer: { recalc, sweepReCalc, sweepMeasureProgress }
  } = state.SierraReducer;
  const { currentResultKey, channelList, resultInfo } = resultReducer;
  const { verificationSubId, verificationId } = resultInfo;
  const { id = "", resultList = [] } = experimentInfo;
  const currentProgress = singleProgress.find(item => item.verificationId === verificationId)
  const expVerificationId = resultList.length ? resultList[0].verificationId : "";
  return {
    currentResultKey,
    channelList,
    verificationId,
    currentProjectId,
    verificationSubId,
    sweepId: id,
    experimentsList: resultList,
    multiSetupResult,
    recalc,
    currentProgress: currentProgress ? currentProgress.progress : false,
    sweepReCalc,
    sweepMeasureProgress,
    expVerificationId,
    currentProjectVerifications
  }
}

const mapDispatch = (dispatch) => ({
  changeResultKey(key) {
    dispatch(changeResultKey(key))
  },
  _saveCurrentSimulationConfig(config) {
    dispatch(saveCurrentSimulationConfig(config))
  },
  updateExperimentInfo(info, currentType) {
    dispatch(updateExperimentInfo(info, currentType))
  },
  _updateMultiInterfaceSetupStatus(group) {
    dispatch(updateMultiInterfaceSetupStatus(group))
  },
  _openNewPage({ pageType, id }) {
    dispatch(openNewPage({ pageType, id }))
  }
})

export default connect(mapState, mapDispatch)(Result);